// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  domain: 'https://test.chillandbite.app',
  apiUrl: 'https://api-test.chillandbite.app',
  dashboardUrl: 'https://bo-test.chillandbite.app/client/dashboard',
  imagesUrl: 'https://api-test.chillandbite.app',
  apple: {
    pay: {
      merchantId: 'merchant.app.chillandbite.test',
    }
  }
};

// export const environment = {
//   production: false,
//   domain: 'https://test.chillandbite.app',
//   apiUrl: 'https://api-test.chillandbite.app',
//   dashboardUrl: 'https://api-test.chillandbite.app/client/dashboard',
//   imagesUrl: 'https://api-test.chillandbite.app',
// };

/*


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
